import { useCallback, useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

export type UTMType = {
	source?: string;
	medium?: string;
	campaign?: string;
	term?: string;
	content?: string;
};

const getReverseMappingUTM = (state: UTMType | undefined) => {
	if (!state) return undefined;
	let obj: Record<string, string> = {};
	Object.keys(state).forEach((key) => {
		obj[`utm_${key}`] = state[key as keyof UTMType] as string;
	});

	return obj;
};

const useUTM = () => {
	const [query] = useSearchParams();

	const [state, setState] = useState<UTMType>();

	const getUTMFromQuery = useCallback(() => {
		if (!query) return null;

		const utm: UTMType = {};
		if (query.get('utm_source')) utm.source = query.get('utm_source') as string;
		if (query.get('utm_medium')) utm.medium = query.get('utm_medium') as string;
		if (query.get('utm_campaign')) utm.campaign = query.get('utm_campaign') as string;
		if (query.get('utm_term')) utm.term = query.get('utm_term') as string;
		if (query.get('utm_content')) utm.content = query.get('utm_content') as string;

		return Object.keys(utm).length === 0 ? null : utm;
	}, [query]);

	useEffect(() => {
		const utmQuery = getUTMFromQuery();

		if (utmQuery) {
			setState(utmQuery);
		}
	}, [query]);

	return {
		state,
		asParams: getReverseMappingUTM(state),
	};
};

export default useUTM;
